<template>
  <div class="be-content">
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="panel panel-default">
            <div class="panel-heading">
              <div class="col-md-4">
                <b>Отчет оператора курортного сбора №1</b>
              </div>
            </div>
            <div class="panel-body">
              <table class="table table-condensed table-hover table-bordered ">
                <thead>
                <tr>
                  <th class="number">№ п/п</th>
                  <th>Ф.И.О лиц, прибывших в курортную местность</th>
                  <th>Дата заселения</th>
                  <th>Дата выбытия</th>
                  <th>Количество дней проживания</th>
                  <th>Размер курортного сбора</th>
                  <th>Документ, подтверждающий льготу</th>
                  <th>Сумма сбора к уплате</th>
                  <th>№ платежного документа</th>
                  <th>Дата платежного документа</th>
                  <th>Сумма платежа</th>
                  <th>Признак плательщика</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td colspan="11" style="text-align: right"><b>Итоговая сумма уплаченного курортного сбора за отчетный период</b>
                  </td>
                  <td></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="panel panel-default">
            <div class="panel-heading">
              <div class="col-md-12">
                <p><b>Отчет оператора курортного сбора №2</b></p>
                <p>Отчет оператора курортного сбора за период: <i><b>{{report.date_start | dateFilter("DD.MM")}} - {{report.date_end | dateFilter("DD.MM.YYYY")}}г.</b></i></p>
                Данные об операторе сбора<br>
                Организация/Индивидуальный предприниматель/физическое лицо: — по ОКПО<br>
                Идентификационный номер налогоплательщика ИНН: <i><b>{{operator.inn}}</b></i><br>
                Вид экономической деятельности:<i><b> {{operator.okved}}</b></i> по ОКВЭД<br>
                Идентификационный номер оператора курортного сбора (из Реестра операторов курортного сбора): <i><b>{{operatorId}}</b></i><br>
                Местонахождение (адрес): <i><b>{{operator.address}}</b></i><br>
              </div>

            </div>
            <div class="panel-body">
              <table class="table table-condensed table-hover table-bordered ">
                <thead>
                <tr>
                  <th class="number">№ п/п</th>
                  <th>Ф.И.О пользователя курортной инфраструктуры</th>
                  <th>Дата рождения пользователя курортной инфраструктуры</th>
                  <th>Документ, удостоверяющий личность пользователя курортной инфраструктуры</th>
                  <th>Место жительства пользователя курортной инфраструктуры</th>
                  <th>Документ, удостоверяющий право на освобождение от уплаты курортного сбора</th>
                  <th>Количество дней проживания на территории проведения эксперимента</th>
                  <th>Размер курортного сбора (руб.)</th>
                  <th>Сумма уплаченного курортного сбора (руб.)</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td colspan="8" style="text-align: right"><b>Итоговая сумма уплаченного курортного сбора за отчетный период</b>
                  </td>
                  <td></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {mapGetters} from 'vuex'

  export default {
    props: ['operatorId', 'reportId'],
    data: function () {
      return {}
    },
    computed: {
      ...mapGetters(
        {
          operatorTypes: 'operatorTypes',
          legalEntityForms: 'legalEntityForms',
          regions: 'regions',
          privilegeCategories: 'privilegeCategories',
          operators: 'operators',
          reports: 'reports'
        }
      ),
      operator () {
        return this.operators.find(item => Number(item.id) === Number(this.operatorId))
      },
      report () {
        return this.reports.find(item => Number(item.id) === Number(this.reportId))
      }
    },
    methods: {
      getNameFromDict (dictName, id) {
        if (dictName.length > 0 && id) {
          return dictName.find(item => Number(item.id) === Number(id)
          ).name
        } else {
          return "\t—"
        }
      },
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/operators/OperatorReports.vue